<template>
    <div class="payFee-page">
		<pay-fee-form @regionShow="regionShow"/>
		<region v-if="regionShowFlg" :options="options" @selectRegion="selectRegion" @regionShow="regionShow"/>
		<pay-fee-result v-if="showResult"/>
		<pay-fee-content-detail/>
	</div>
</template>

<script>
	import {mapState, mapMutations} from 'vuex'
	import Region from '../../components/region/'
	import PayFeeForm from './pay-fee-form'
	import PayFeeResult from './pay-fee-result'
	import PayFeeContentDetail from './pay-fee-content-detail'
	import {RegionGroup} from '../../constant/common'
    export default {
        name: "PayFee",
		components: {
			Region,
			PayFeeForm,
			PayFeeResult,
			PayFeeContentDetail
		},
		data () {
        	return {
				regionShowFlg: false,
				options: {
					source: 'payFee',
					isOrigin: true,
					selectOriginAreaCode: '',
					regionTabs: RegionGroup.regionTabs
				}
			}
		},
		beforeCreate () {
			this.$store.commit('setTitle', this._ll('运费时效查询'))
		},

		computed: {
			...mapState('payFee', [
				'selectOriginAreaCode',
				'errorMsg',
				'showResult'
			])
		},

		watch: {
			selectOriginAreaCode: function (val, oldVal) {
				if (val !== oldVal) {
					this.options.selectOriginAreaCode = val
				}
			},
			flag () {
				this.$toast(this._ll(this.errorMsg))
			}
		},
		methods: {
			...mapMutations('payFee', ['selectRegion']),
			...mapMutations(['setTitle']),
			regionShow: function (showFlg, isOrigin) {
				this.regionShowFlg = showFlg
				this.options.isOrigin = isOrigin
			}
		}
    }
</script>




// WEBPACK FOOTER //
// src/pages/payFee/index.vue